export const techs = [
    {id:1,techName:"React",imageSource:"/techs/reactLogo.svg"},
    {id:2,techName:".Net Core",imageSource:"/techs/core.png"},
    {id:3,techName:"Javascript",imageSource:"/techs/js.png"},
    {id:4,techName:"Sql",imageSource:"/techs/sql.png"},
    {id:5,techName:"Git",imageSource:"/techs/git.png"},
    {id:6,techName:"Azure Devops",imageSource:"/techs/azure.png"},
    {id:7,techName:"Angular",imageSource:"/techs/angular.png"},
    {id:8,techName:"Unity",imageSource:"/techs/unity.svg"},
    {id:9,techName:"Html",imageSource:"/techs/html.jpg"},
    {id:10,techName:"Css",imageSource:"/techs/css.png"},
]